// src/components/cta26.js
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './cta26.css'
import { useTranslation } from 'react-i18next'

const CTA26 = ({
  heading1 = undefined,
  content1 = undefined,
  action1 = undefined,
  onRegisterClick
}) => {
  const { t } = useTranslation();

  return (
    <section className="cta26-section thq-section-padding">
      <div className="cta26-max-width thq-section-max-width">
        <div className="cta26-card">
          <div className="cta26-content">
            <h2 className="cta26-heading thq-heading-2">
              {heading1 ?? (
                <Fragment>
                  <span>{t('home.CTA26.heading', 'Ready to Boost Your Business?')}</span>
                </Fragment>
              )}
            </h2>
            <p className="cta26-description thq-body-large">
              {content1 ?? (
                <Fragment>
                  <span>{t('home.CTA26.content', 'Join local business owners automating sales, appointments, and support with Paco on WhatsApp.')}</span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="cta26-actions">
            <button
              type="button"
              className="cta26-button thq-button-filled"
              onClick={onRegisterClick}
            >
              <span>
                {action1 ?? (
                  <Fragment>
                    <span>{t('home.CTA26.action', 'Start Free Trial')}</span>
                  </Fragment>
                )}
              </span>
              <span className="cta26-button-arrow">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

CTA26.propTypes = {
  heading1: PropTypes.element,
  content1: PropTypes.element,
  action1: PropTypes.element,
  onRegisterClick: PropTypes.func,
}

export default CTA26